module.exports = __webpack_public_path__ + "img/c061f334fed85538811247a6b2b4a66200db6de8.bc131b85.png";